import { useState } from 'react';
import { httpDelete, httpPost, httpPut } from '../../../../components/utils';

const useApplicationMutations = (onSuccessCallback = () => {}) => {
    const reqUrl = `/accessAnalysis/applications`;
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    const createApplicationMutation = async (data) => {
        setIsLoading(true);
        try {
            await httpPost(reqUrl, data);
            onSuccessCallback();
        } catch (e) {
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    };

    const deleteApplicationMutation = async (appId) => {
        setIsLoading(true);
        try {
            await httpDelete(`${reqUrl}/${appId}`);
            onSuccessCallback();
        } catch (e) {
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    };

    const updateApplicationMutation = async (applicationId, data) => {
        setIsLoading(true);
        try {
            await httpPut(`${reqUrl}/${applicationId}`, data);
            onSuccessCallback();
        } catch (e) {
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    };

    return { createApplicationMutation, deleteApplicationMutation, updateApplicationMutation, isLoading, isError };
};

export default useApplicationMutations;
